module.exports = __webpack_public_path__ + "static/img/3.61d29bb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/users/3.jpg
// module id = 2GvU
// module chunks = 17